







































































































































































































































































































































































import AsuhanKeperawatanGawatDarurat from "@/services/AsuhanKeperawatanGawatDarurat";
import { appModule } from "@/store/modules/app";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import ModalAskepOptions from "@/components/modal/ModalAskepOptions.vue";
import ImplementasiObatInline from "@/components/AskepGadar/ImplementasiObatInline.vue";
import {
  makeListWithEditable,
  dedupeAsuhanItems
} from "@/utility/AsuhanKeperawatanHelper";
import { isEmpty } from "lodash";

interface Options {
  type: string;
  title: string;
  options: any[];
  column: number;
}

@Component({
  components: {
    ModalAskepOptions,
    ImplementasiObatInline
  }
})
export default class AskepGadarInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop() editedItem = null as {
    id: number;
    diagnosis: any;
    tujuan: any[];
    rencana: any[];
    implementasi: any[];
    creator: any;
    examinedAt: string;
  };
  @Ref() readonly diagAutocomplete;
  @Ref() readonly dateTimePicker;
  @Ref() readonly tujuanItemRow: HTMLInputElement;
  @Ref() readonly rencanaItemRow: HTMLInputElement;
  @Ref() readonly implementasiItemRow: HTMLInputElement;
  // @Ref() readonly implementasiTimepicker: HTMLInputElement;

  diagSearch = null;
  showImplementasiTimepicker = false;

  get show() {
    return this.value;
  }
  set show(val) {
    this.$emit("input", val);
  }

  get diagnosisOptions() {
    return AsuhanKeperawatanGadarStore.listDiag
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(item => ({
        ...item,
        displayName: (item as any).kode
          ? `${(item as any).kode} — ${item.name}`
          : item.name
      }));
  }

  get tujuanOptions() {
    const list = AsuhanKeperawatanGadarStore.listTujuan
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));

    return makeListWithEditable(list, ".....");
  }

  get rencanaOptions() {
    const list = AsuhanKeperawatanGadarStore.listRencana
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));

    return makeListWithEditable(list, ".....");
  }

  get implementasiOptions() {
    const list = AsuhanKeperawatanGadarStore.listImplementasi
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(item => ({ ...item, time: null }));

    return makeListWithEditable(list, ".....");
  }

  get optionsType() {
    return [
      {
        type: "tujuan",
        title: "Tujuan Keperawatan",
        options: this.tujuanOptions,
        column: 2
      },
      {
        type: "rencana",
        title: "Rencana Keperawatan",
        options: this.rencanaOptions,
        column: 4
      },
      {
        type: "implementasi",
        title: "Implementasi Keperawatan",
        options: this.implementasiOptions,
        column: 3
      }
    ];
  }

  modalOptionsTitle = "Cari Opsi...";
  modalTitle = "Tambah Askep";

  id = null;
  diagnosis = null;
  tujuan = [];
  rencana = [];
  implementasi = [];
  creator = null;
  examinedAt = null;

  saving = false;

  // client-side v-for key generator for drug entries (keeps inline state
  // stable when adding/removing drugs in one implementasi row)
  obatKeySeq = 0;

  showModal = false;
  groupItem = [];
  selectedOptionItems = [];
  activeOptionsType: Options = null;

  async mounted() {
    // await AsuhanKeperawatanGadarStore.getListDiagnosis();
  }

  setAskepOptionItems(val) {
    if (this.activeOptionsType) {
      this[this.activeOptionsType.type] = dedupeAsuhanItems(val);
    }
  }

  openInputTujuanModal() {
    const options = this.optionsType.find(item => item.type === "tujuan");

    this.activeOptionsType = options;
    this.groupItem = options.options;
    this.selectedOptionItems = this.tujuan;

    this.showModal = true;
  }

  openInputRencanaModal() {
    const options = this.optionsType.find(item => item.type === "rencana");

    this.activeOptionsType = options;
    this.groupItem = options.options;
    this.selectedOptionItems = this.rencana;

    this.showModal = true;
  }

  openInputImplementasiModal() {
    const options = this.optionsType.find(item => item.type === "implementasi");

    this.activeOptionsType = options;
    this.groupItem = options.options;
    this.selectedOptionItems = this.implementasi;

    this.showModal = true;
  }

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  get user() {
    return userModule.user;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get diagnosisInput() {
    // store id+name only — the picked option carries the whole nested master
    // (luaran/intervensi.item); persisting it would bloat content JSON.
    if (isEmpty(this.diagnosis)) return null;
    const d = this.diagnosis as any;
    return { id: d.id, name: d.name };
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      content: {
        diagnosis: this.diagnosisInput,
        tujuan: this.tujuan,
        rencana: this.rencana,
        implementasi: this.implementasi,
        // perawat: this.listPerawat.find(prwt => prwt.id == this.creator.id),
        perawat: this.creator,
        examinedAt: this.examinedAt
          ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
          : null
      }
    };
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const sendRequest = this.id
        ? AsuhanKeperawatanGawatDarurat.update(this.id, this.input)
        : AsuhanKeperawatanGawatDarurat.create(this.input);

      sendRequest
        .then(() => {
          appModule.NoticeDelay("Berhasil Simpan Asuhan Keperawatan");

          this.close();

          this.$emit("saved");
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  setPerawat(val) {
    this.creator = val;
  }

  clearInputField() {
    this.id = null;
    this.diagnosis = null;
    this.tujuan = [];
    this.rencana = [];
    this.implementasi = [];
    this.creator = {
      id: this.user.id,
      nama: this.user.nama
    };
    this.examinedAt = null;

    this.diagSearch = null;

    // trigger datetimepicker to clear value
    this.$refs.dateTimePicker["clearHandler"]();
  }

  @Watch("show")
  changedShow(val) {
    if (val && this.editedItem !== null) {
      this.modalTitle = "Edit Askep";

      this.id = this.editedItem.id;
      this.diagnosis = this.editedItem.diagnosis;
      this.tujuan = this.editedItem.tujuan;
      this.rencana = this.editedItem.rencana;
      this.implementasi = (this.editedItem.implementasi || []).map(it => {
        if (!it || !it.obat) return it;
        // normalize legacy single-object obat -> array, and key each entry
        const list = Array.isArray(it.obat) ? it.obat : [it.obat];
        return {
          ...it,
          obat: list.map(d => ({ ...d, _k: this.nextObatKey() }))
        };
      });
      this.creator = this.editedItem.creator;
      this.examinedAt = new Date(this.editedItem.examinedAt);
    } else {
      this.modalTitle = "Tambah Askep";
    }
  }

  onDiagnosisChange(val) {
    if (isEmpty(val) || !val.id || this.id !== null) {
      return;
    }

    // Wholesale re-seed on every diagnosis change (create mode) from the
    // nested Ref Askep (System A) master carried on the picked option —
    // same pattern as Ranap. Switching diagnosis refreshes the auto-fill.
    this.tujuan = (Array.isArray(val.luaran) ? val.luaran : []).map(l => ({
      id: l.id,
      name: l.kode ? `${l.kode} ${l.name}` : l.name,
      editable: false
    }));

    const items = (val.intervensi || []).reduce(
      (a, i) => a.concat(i.item || []),
      []
    );
    const seen: any = {};
    this.implementasi = items
      .filter(it => {
        if (!it || it.id == null || seen[it.id]) return false;
        seen[it.id] = true;
        return true;
      })
      .map(it => ({
        id: it.id,
        name: it.name || it.implementasi,
        editable: false,
        time: null
      }));
  }

  get isAnyTujuanCustom() {
    return this.tujuan.some(item => !item.id);
  }

  get isAnyRencanaCustom() {
    return this.rencana.some(item => !item.id);
  }

  get isAnyImplementasiCustom() {
    return this.implementasi.some(item => !item.id);
  }

  close() {
    if (this.isAnyTujuanCustom) {
      AsuhanKeperawatanGadarStore.getListTujuan();
    }

    if (this.isAnyRencanaCustom) {
      AsuhanKeperawatanGadarStore.getListRencana();
    }

    if (this.isAnyImplementasiCustom) {
      AsuhanKeperawatanGadarStore.getListImplementasi();
    }

    this.show = false;
    this.clearInputField();
  }

  addNewAsuhanItem(catName) {
    this[catName] = [
      ...this[catName],
      // tambahin time untuk kategori yg perlu isian waktu
      {
        id: null,
        editable: true,
        name: ".....",
        time: ["implementasi"].includes(catName) ? null : undefined
      }
    ];

    this.$nextTick(() => {
      const inputRows = this[`${catName}ItemRow`].length;
      this[`${catName}ItemRow`][inputRows - 1].focus();
    });
  }

  removeAsuhanItem(catName, index) {
    this[catName] = [
      ...this[catName].slice(0, index),
      ...this[catName].slice(index + 1)
    ];
  }

  nextObatKey() {
    this.obatKeySeq += 1;
    return this.obatKeySeq;
  }

  toggleObatFlag(index) {
    const item = this.implementasi[index];
    if (!item) return;

    if (item.obat) {
      this.removeObatFlag(index);
      return;
    }

    // Tag this item as Pemberian Obat — one row can hold multiple drugs
    const next = {
      ...item,
      editable: true,
      obat: [{ _k: this.nextObatKey() }]
    };
    if (!Object.prototype.hasOwnProperty.call(next, "time") || next.time == null) {
      const now = new Date();
      next.time = `${String(now.getHours()).padStart(2, "0")}:${String(
        now.getMinutes()
      ).padStart(2, "0")}`;
    }
    this.$set(this.implementasi, index, next);
  }

  removeObatFlag(index) {
    const item = this.implementasi[index];
    if (!item) return;
    const next = { ...item };
    delete next.obat;
    this.$set(this.implementasi, index, next);
  }

  addObatEntry(index) {
    const item = this.implementasi[index];
    if (!item) return;
    const obat = Array.isArray(item.obat) ? item.obat.slice() : [];
    obat.push({ _k: this.nextObatKey() });
    this.$set(this.implementasi, index, { ...item, obat });
  }

  removeObatEntry(index, di) {
    const item = this.implementasi[index];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    obat.splice(di, 1);
    if (obat.length === 0) {
      // no drugs left — untag the whole row
      this.removeObatFlag(index);
      return;
    }
    const next = { ...item, obat };
    this.applyObatNarrative(next);
    this.$set(this.implementasi, index, next);
  }

  onObatInput(index, di, obatPayload) {
    const item = this.implementasi[index];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    const prevK = obat[di] && obat[di]._k;
    obat[di] = {
      ...obatPayload,
      _k: prevK != null ? prevK : this.nextObatKey()
    };
    const next = { ...item, obat };
    this.applyObatNarrative(next);
    this.$set(this.implementasi, index, next);
  }

  // Rebuild the implementasi row's narrative from every drug entry, unless the
  // user has typed their own. Single drug keeps its plain narrative; multiple
  // drugs join as "Pemberian Obat: A, B".
  applyObatNarrative(item) {
    const shouldAutoFill =
      !item.name || item.name === "....." || item._autoNamedBy === "obat";
    if (!shouldAutoFill) return;
    const parts = (item.obat || [])
      .map(function (d) {
        return d && d._narrative;
      })
      .filter(Boolean);
    if (parts.length) {
      // each part already reads "Injeksi X / Pemberian Obat X" — join, no prefix
      item.name = parts.join(" + ");
      item._autoNamedBy = "obat";
    }
  }
}
